import { useTrivia } from "../../../../hooks";

type StartTriviaProps = {
  startTrivia: () => void;
}

export const StartTrivia = ({ startTrivia }: StartTriviaProps) => {
  const { isLoadTrivia } = useTrivia();

  const handleStartTrivia = () =>{
    startTrivia();
  }

  return (
    <div className="trivia">
        <div className="trivia__intro">
            <h2 className="trivia__intro-title">Ponte a prueba!</h2>
            <p className="trivia__intro-txt">
              Completa esta evaluación y descarga el reporte de
              resultados
            </p>
            {
              !isLoadTrivia ? (
                <button type="button" className="btn btn-primary" onClick={handleStartTrivia}>
                  <span className="btn__label" >Iniciar</span>
                </button>
              ) : (
                <div>Cargando...</div>
              )
            }
            
        </div>
    </div>
  )
}